module.exports = __webpack_public_path__ + "static/media/poster.191a77e7.jpg";